import _JSON$stringify from "/app/node_modules/babel-runtime/core-js/json/stringify";
import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required, numeric, minLength } from "vuelidate/lib/validators";
import { ConflictError, BadRequestError } from "~/abstractions/errors";
import { charactersSpecial } from "~/validators";
import { lettersAndNumbersMixin } from "~/mixins";

export default {
  mixins: [lettersAndNumbersMixin],
  data: function data() {
    return {
      actionButton: "",
      title: "",
      editChannel: false,
      switchState: false,
      checkbox: false,
      nameChannel: "",
      sending: false,
      value: null,
      idChannel: null,
      conditionalStatus: false,
      message: "",
      conditionalShowMessageStatus: false,
      isHaveNotTeams: false,
      loading: false,
      timeout: null,
      resultValidNameService: false,
      channelIsActive: false
    };
  },
  validations: function validations() {
    return {
      nameChannel: {
        required: required,
        charactersSpecial: charactersSpecial("nameChannel")
      }
    };
  },

  methods: {
    createChannel: function createChannel() {
      this.editChannel = true;
      this.title = "Nuevo Canal";
      this.actionButton = "Crear";
      this.conditionalStatus = true;
      this.switchState = true;
      this.loading = true;
    },
    editThisChannel: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var admin;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.editChannel = true;
                this.conditionalStatus = true;
                this.title = "Editar Canal";
                this.actionButton = "Guardar";

                // console.log("edit");
                _context.next = 6;
                return this.$store.dispatch("channel/findChannelForEdit", this.idChannel);

              case 6:
                admin = _context.sent;

                this.nameChannel = admin.Name;
                this.checkbox = admin.VirtualProducts;
                this.switchState = admin.IsActive;
                this.value = admin.IdBoss;
                if (admin.IsActive == false) {
                  this.conditionalShowMessageStatus = false;
                }
                this.resultValidNameService = true;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function editThisChannel() {
        return _ref.apply(this, arguments);
      }

      return editThisChannel;
    }(),
    onSubmit: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.$v.$touch();
                _context2.prev = 1;

                if (!(this.$isBoss() == true)) {
                  _context2.next = 10;
                  break;
                }

                _context2.next = 5;
                return this.$store.dispatch("channel/editChannel", {
                  idChannel: this.idChannel,
                  name: this.nameChannel,
                  virtualProducts: this.checkbox,
                  isActive: this.switchState,
                  idBoss: this.value
                });

              case 5:
                this.$emit("upDateListBoss");
                this.$emit("completeForm");
                this.cancel();
                _context2.next = 29;
                break;

              case 10:
                _context2.prev = 10;

                if (!(this.title === "Nuevo Canal")) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 14;
                return this.$store.dispatch("channel/createdNewChannel", {
                  name: this.nameChannel,
                  virtualProducts: this.checkbox,
                  idBoss: this.value,
                  isActive: this.switchState
                });

              case 14:
                //Mostrando canales agregados dinamicamente
                this.$emit("updateShowChannels", this.value);
                this.$store.commit("boss/updateNumberChannels", this.value);
                _context2.next = 22;
                break;

              case 18:
                _context2.next = 20;
                return this.$store.dispatch("channel/editChannel", {
                  idChannel: this.idChannel,
                  name: this.nameChannel,
                  virtualProducts: this.checkbox,
                  idBoss: this.value,
                  isActive: this.switchState
                });

              case 20:
                //Editar nombre del Equipo Dinamicamente
                this.$emit("toTeamsTable", {
                  val: { name: this.nameChannel, active: this.switchState }
                });
                this.$emit("upDateTeam");

              case 22:
                this.cancel();
                this.$emit("completeForm");
                _context2.next = 29;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2["catch"](10);

                if (_context2.t0 instanceof ConflictError) {
                  // console.log(error);
                  if (this.title === "Nuevo Canal") {
                    this.$swal("No se pudo Crear", _context2.t0.message, "warning");
                  } else {
                    this.$swal("No se pudieron guardar tus cambios", _context2.t0.message, "warning");
                  }
                } else {
                  this.$controlMessage(_context2.t0);
                }

              case 29:
                _context2.next = 34;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t1 = _context2["catch"](1);

                if (_context2.t1 instanceof ConflictError) {
                  this.$swal("Error", _context2.t1.message, "warning");
                } else if (_context2.t1 instanceof BadRequestError) {
                  this.$swal("Error", _JSON$stringify(_context2.t1.data.constraints[0].constraints.isEmail), "warning");
                } else {
                  this.$controlMessage(_context2.t1);
                }

              case 34:
                this.cancel();
                this.dialog = false;

              case 36:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 31], [10, 26]]);
      }));

      function onSubmit() {
        return _ref2.apply(this, arguments);
      }

      return onSubmit;
    }(),
    cancel: function cancel() {
      this.editChannel = false;
      this.nameChannel = "";
      this.checkbox = false;
      this.$v.$reset();
    },
    validName: function validName(value) {
      var _this = this;

      clearTimeout(this.timeout);
      if (this.nameChannel === "") return true;
      this.timeout = setTimeout(_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;

                if (!(_this.title == "Nuevo Canal")) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 4;
                return _this.$store.dispatch("channel/validNewChannelName", {
                  name: _this.nameChannel
                });

              case 4:
                _context3.next = 8;
                break;

              case 6:
                _context3.next = 8;
                return _this.$store.dispatch("channel/validEditChannel", {
                  idChannel: _this.idChannel,
                  name: _this.nameChannel
                });

              case 8:
                _this.resultValidNameService = true;
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

                _this.message = _context3.t0.message;
                _this.resultValidNameService = false;

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[0, 11]]);
      })), 500);
    }
  },
  computed: {
    nameChannelErrorMessages: function nameChannelErrorMessages() {
      var errors = [];
      if (!this.$v.nameChannel.$dirty) return errors;
      !this.$v.nameChannel.required && errors.push("Campo obligatorio");
      !this.$v.nameChannel.charactersSpecial && errors.push("Caracter inválido");
      !this.resultValidNameService && errors.push(this.message);
      return errors;
    },
    channelIsActiveChange: function channelIsActiveChange() {
      if (this.$route.query.bossStatus) {
        this.channelIsActive = this.$route.query.bossStatus;
      } else if (this.$route.query.channelStatus) {
        this.channelIsActive = !this.$route.query.channelStatus;
      } else if (this.$isBoss()) {
        this.channelIsActive = true;
      } else {
        this.channelIsActive = false;
      }
    }
  },
  watch: {
    switchState: function switchState(val) {
      if (val == false && this.isHaveNotTeams == false) {
        this.conditionalShowMessageStatus = true;
      } else {
        this.conditionalShowMessageStatus = false;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.channelIsActiveChange;
    });
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/edit-channel.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/edit-channel.vue
// module chunks = 4 6 9